import { v4 as uuidv4 } from 'uuid';

class CookieHelper {
  static setCookie(cName:string, cValue:string, expDays:number) {
    const date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${cName}=${cValue}; ${expires}; path=/`;
  }

  static getUserAutofactId(): string {
    const userAfIdCookie = document.cookie.replaceAll(' ', '').split(';').filter((a) => a.includes('af_id'))[0];
    let userAfIdCookieValue = userAfIdCookie?.split('=')[1];
    if (!userAfIdCookieValue) {
      userAfIdCookieValue = uuidv4();
      CookieHelper.setCookie('af_id', userAfIdCookieValue, 3);
    }
    return userAfIdCookieValue;
  }
}

export default CookieHelper;
